export default __webpack_public_path__ + "static/media/ID_LIV_Myst.9e0cf22a.jpg";